import styled from 'styled-components';

export const UploadContainer = styled.div`
  .ant-upload-list {
    margin-top: 16px;
  }
`;




